import { Container, Heading, ContainerProps } from '@hover/blueprint';
import React, { FC } from 'react';

interface Props extends ContainerProps {
  header: string;
  desc: string;
}

const HeaderDescription: FC<Props> = ({ header, desc, ...restProps }) => (
  <Container
    maxW={1000}
    overflow="hidden"
    {...restProps}
    centerContent
    flexDir="column"
  >
    <Heading
      maxW="5xl"
      size={{ base: 500, tablet: 600, desktop: 700 }}
      color="neutral.700"
      textAlign="center"
      isLight
      style={{ marginBottom: 24 }}
    >
      {header}
    </Heading>
    <Container maxW={{ base: 800, tablet: 900 }} px={{ base: 0, desktop: 500 }}>
      <Heading
        size={{ base: 300, desktop: 500 }}
        color="neutral.700"
        textAlign="center"
        fontWeight={{ base: 400, desktop: 400 }}
        style={{ marginBottom: 0 }}
      >
        {desc}
      </Heading>
    </Container>
  </Container>
);

export default HeaderDescription;
